import { render } from "./AllegationDetailsDialog.vue?vue&type=template&id=947f5fb8&ts=true"
import script from "./AllegationDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./AllegationDetailsDialog.vue?vue&type=script&lang=ts"

import "./AllegationDetailsDialog.vue?vue&type=style&index=0&id=947f5fb8&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__